<template>
  <div>
    <van-nav-bar
      :fixed="true"
      title="职位详情"
      left-arrow
      @click-left="$router.back()"
    />
    <van-cell-group>
      <van-row class="divinfo">
        <van-col span="4">
          <van-image width="32" height="32" :src="logo" />
        </van-col>
        <van-col span="20">
          <div class="name">{{ job.name }}</div>
          <div class="info">{{ job.group }} | 本科及以上｜全国</div>
          <div class="date">
            {{ job._updatetime | parseTime("{y}-{m}-{d}") }}
          </div></van-col
        >
      </van-row>
    </van-cell-group>

    <van-cell-group class="divjobdata">
      <div>职位描述</div>
      <div class="info" >
        <div v-for="(d,i) in job.jobDescription" :key="i"> 
          {{i+1}}、{{d }}
        </div>
      </div>
    </van-cell-group>
    <van-cell-group class="divjobdata">
      <div>任职要求</div>
      <div class="info" >
        <div v-for="(d,i) in job.jobRequirements" :key="i"> 
          {{i+1}}、{{d }}
        </div>
      </div>
    </van-cell-group>

     <van-row class="divinfo">
           <van-col span="10" offset="14">
                <van-button  type="warning" block @click="$router.push('/resume/' + job._id)" >我要投递</van-button>
           </van-col>
     </van-row>
  </div>
</template>
<script>
import { Toast } from "vant";

export default {
  name: "edit",
  props: {},
  data() {
    return {
      logo: require("@/assets/img/logo.jpg"),
      id: "",
      remark: "",
      job: {},
      activeNames: "",
      returnvisitList: [],
    };
  },

  created() {
    this.id = this.$route.params.id;
    this.$request.jobDetial(this.id).then((res) => {
      if (res.code == 0) {
        this.job = res.data;
      }
    });
  },
  methods: {
    
  },
  components: {},
};
</script>
<style scoped lang="less">
// .van-cell {
//   margin: 0px;
//   padding: 0px;
// }
.divinfo {
  margin-top: 50px;
  padding: 10px;
}
.divdata {
  margin: 10px;
  margin-left: 10px;
  padding: 10px;
  font-size: 14px;
}
.divjobdata{
margin: 10px;
  margin-left: 20px;
  padding: 10px;
  font-size: 14px;
}
.info {
  font-size: 14px;
  // margin: 5px;

  span {
    font-size: 12px;
  }
}
.edit {
  box-sizing: border-box;
  padding: 10px;
  background: #fff;
}
.name {
  font-size: 14px;
}
.date {
  font-size: 12px;

  color: lightgray;
}
.info {
  color: gray;
  font-size: 12px;
}
</style>